//import Cookies from "js-cookie";
import { refresh } from './game.mjs';

const scoreCorrect = document.getElementById("score_correct");
const scoreTotal = document.getElementById("score_total");

const levelSlider = document.getElementById("level_slider");
const levelIcons = document.getElementsByClassName("level-icon");

levelSlider.oninput = function() {
    //Cookies.set('level', this.value, { sameSite: 'strict' });
    window.localStorage.setItem('level', this.value);
    refresh();
}

export function incTotal() {
    let current = parseInt(scoreTotal.innerText);
    scoreTotal.innerText = current + 1;
}

export function incScore() {
    let current = parseInt(scoreCorrect.innerText);
    scoreCorrect.innerText = current + 1;

    //document.cookie = "correct=" + (current + 1);
    // {expires: 1/24} = 1 time
    //Cookies.set('correct', current + 1, { sameSite: 'strict' });
    window.sessionStorage.setItem('score', current + 1);

    // incTotal();
}

export function getScore() {

    //let score = Cookies.get('correct');
    let score = window.sessionStorage.getItem('score');
    scoreCorrect.innerText = score ?? '0';
    
    //return parseInt(scoreCorrect.innerText);
}

export function getLevel() {
    //let level = Cookies.get('level');
    let level = window.localStorage.getItem('level');
    levelSlider.value = level ?? '1';
    let levelInt = parseInt(levelSlider.value);
    
    levelIcons[levelInt - 1].style.display = 'block';

    return levelInt;
}